<template>
    <div class="w-full h-full" style="background-color: rgba(215, 215, 215, 0.11)">
        <div class="w-full flex flex-row">
            <div class="h-full flex flex-col p-5 md:p-20 justify-center w-1/2 mt-0 2xl:ml-72">
              <editable-headline :field="destination.pivot.id + '-plan'" :default="'Planlagt i ' + destination.name" :large="true"/>
                <Accordion
                    v-if="activities.length > 0"
                    class="my-3"
                    @opened="setMarkers(activities)"
                    @closed="resetMarkers"
                >
                    <template #title>
                        <span class="text-3xl mb-4 md:text-xl hover:underline hover:success-dark">Activities</span>
                    </template>
                    <template #content>
                        <div
                            v-for="activity in activities"
                            class="my-8"
                        >
                          <span @click="setMarkers([activity], 15)" class="text-lg font-semibold cursor-pointer md:text-base md:font-normal hover:underline hover:success-dark">
                            {{ activity.name }}
                          </span>
                        </div>
                    </template>
                </Accordion>
                <Accordion
                    v-if="lodging.length > 0"
                    class="my-3"
                    @opened="setMarkers(lodging)"
                    @closed="resetMarkers"
                >
                    <template #title>
                        <span class="text-3xl mb-4 md:text-xl hover:underline hover:success-dark">Lodging</span>
                    </template>
                    <template #content>
                        <div
                            v-for="lodge in lodging"
                            class="my-8"
                        >
                          <span @click="setMarkers([lodge])" class="text-lg font-semibold cursor-pointer md:text-base md:font-normal hover:underline hover:success-dark">
                            {{ lodge.name }}
                          </span>
                        </div>
                    </template>
                </Accordion>
                <Accordion
                    v-if="eateries.length > 0"
                    class="my-3"
                    @opened="setMarkers(eateries)"
                    @closed="resetMarkers"
                >
                    <template #title>
                        <span class="text-3xl mb-4 md:text-xl hover:underline hover:success-dark">Eateries</span>
                    </template>
                    <template #content>
                        <div
                            v-for="eatery in eateries"
                            class="my-8"
                        >
                          <span @click="setMarkers([eatery], 15)" class="text-lg font-semibold cursor-pointer md:text-base md:font-normal hover:underline hover:success-dark">
                            {{ eatery.name }}
                          </span>
                        </div>
                    </template>
                </Accordion>
                <div class="text-gray-600 flex justify-center items-center h-64" v-if="activities.length === 0 && lodging.length === 0 && eateries.length === 0">
                    Nothing is added yet
                </div>
            </div>
            <div class="w-full md:w-1/2 h-full">
                <GMapMap
                    :center="markers.length > 0 ? { lat: center_lats, lng: center_lngs } : { lat: destination.location.coordinates[1], lng: destination.location.coordinates[0] }"
                    :zoom="markers.length > 0 ? zoomCenter : 10"
                    map-type-id="terrain"
                    :options="{scrollwheel: false,}"
                    style="width: 100%; height: 30rem"
                >
                    <GMapMarker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        :clickable="true"
                        @click="m.position"
                    />
                    <GMapMarker
                        v-if="markers.length === 0"
                        :position="{
                            lat: destination.location.coordinates[1],
                            lng: destination.location.coordinates[0]
                        }"
                        :clickable="true"
                    />
                </GMapMap>
            </div>
        </div>
    </div>
</template>

<script setup>
import Accordion from '@/ComponentsDeprecated/Accordion/Accordion';
import {computed, onMounted, ref, watch} from "vue";
import {useProposalOldStore} from "@/Stores/ProposalOld";
import EditableHeadline from "@/ComponentsDeprecated/Proposal/EditableHeadline";

const props = defineProps({
    destination: {
        type: Object,
        required: true
    }
})

const markers = ref([])
const store = useProposalOldStore()

onMounted(() => {
    resetMarkers()
})

function setMarkers(locations) {
    let timeMarkers = []
    locations.forEach((location) => {
        timeMarkers.push({
            headline: location.name,
            position: {
                lat: location.place.location.coordinates[1],
                lng: location.place.location.coordinates[0]
            }
        })
    })
    markers.value = timeMarkers
}
const activities = computed(() => store.activities.filter(activity => activity.destination_id === props.destination.id))
const lodging = computed(() => store.lodging.filter(lodging => lodging.destination_id === props.destination.id))
const eateries = computed(() => store.eateries.filter(eatery => eatery.destination_id === props.destination.id))

watch(() => activities, () => {
    resetMarkers()
})

watch(() => eateries, () => {
    resetMarkers()
})

watch(() => lodging, () => {
    resetMarkers()
})

function resetMarkers() {
    let timeMarkers = []
    activities.value.forEach((activity) => {
      if(activity.place) {
        timeMarkers.push({
            headline: activity.name,
            position: {
                lat: activity.place.location.coordinates[1],
                lng: activity.place.location.coordinates[0]
            }
        })
      }
      else if(activity.location) {
        timeMarkers.push({
          headline: activity.name,
          position: {
            lat: activity.location.coordinates[1],
            lng: activity.location.coordinates[0]
          }
        })
      }
    })
    lodging.value.forEach((activity) => {
      if(activity.place) {
        timeMarkers.push({
          headline: activity.name,
          position: {
            lat: activity.place.location.coordinates[1],
            lng: activity.place.location.coordinates[0]
          }
        })
      }
      else if(activity.location) {
        timeMarkers.push({
          headline: activity.name,
          position: {
            lat: activity.location.coordinates[1],
            lng: activity.location.coordinates[0]
          }
        })
      }
    })
    eateries.value.forEach((activity) => {
      if(activity.place) {
        timeMarkers.push({
          headline: activity.name,
          position: {
            lat: activity.place.location.coordinates[1],
            lng: activity.place.location.coordinates[0]
          }
        })
      }
      else if(activity.location) {
        timeMarkers.push({
          headline: activity.name,
          position: {
            lat: activity.location.coordinates[1],
            lng: activity.location.coordinates[0]
          }
        })
      }
    })

    markers.value = timeMarkers;
}

const center_lats = computed(() => {
    let lats = markers.value.map(a => a.position.lat)
    let latMax = Math.max(... lats)
    let latMin = Math.min(... lats)
    return (latMin+latMax)/2 || 0;
})

const center_lngs = computed(() => {
    let lngs = markers.value.map(a => a.position.lng)
    let lngMax = Math.max(... lngs)
    let lngMin = Math.min(... lngs)
    return (lngMin+lngMax)/2 || 0;
})

const zoomCenter = computed(() => {
    if (markers.value.length === 1) return 16
    let lngs = markers.value.map(a => a.position.lng)
    let lats = markers.value.map(a => a.position.lat)
    let lngMax = Math.max(... lngs)
    let lngMin = Math.min(... lngs)
    let latMax = Math.max(... lats)
    let latMin = Math.min(... lats)
    let max = Math.max(latMax-latMin, lngMax-lngMin)
    return (2.6-(max*2))*5

})
</script>
